import React from 'react';

import { messages } from './messages';
import { BLOCKING_BEHAVIOR } from '../../../../../../constants/fraud-constants';
import { LossPreventionCard } from '../../loss-prevention-card';

type InternationalAddressMismatchCardProps = {
  isCardDisabled: boolean;
  onToggle: (enabled: boolean) => void;
};

export const InternationalAddressMismatchCard = ({ isCardDisabled, onToggle }: InternationalAddressMismatchCardProps) => {
  return (
    <LossPreventionCard
      blockingBehavior={BLOCKING_BEHAVIOR.FLAGS}
      description={messages.description}
      isCardDisabled={isCardDisabled}
      onToggle={onToggle}
      title={messages.title}
    />
  );
};
